import React from 'react';
import { IconButton, IconButtonType, IconButtonSize, IconButtonVariant } from '@ids/react-icon-button';
import { Ui16Plus } from '@ids/react-icons';
import { useNavigate } from 'react-router-dom';
import { TeamType } from '../../../../../Enums/TeamType';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';

const TeamNode = ({ teamNode, currentTeam }) => {
  const navigate = useNavigate();

  const hasChildren = teamNode.children && teamNode.children.length > 0;

  return (
    <li className="teamPage-teamHierarchy-node">
      <div>
        <div>{teamNode.name ?? teamNode.firstAgentName}</div>
        <div
          className={`teamPage-teamHierarchy-codePrefix clickable ${
            currentTeam.codePrefix === teamNode.codePrefix ? 'teamPage-teamHierarchy-currentTeam' : ''
          }`}
          onClick={() => {
            window.location.href = `/team/view/${teamNode.codePrefix}`;
          }}>
          {teamNode.codePrefix}
        </div>
      </div>

      {hasChildren && (
        <ul className="tree-children">
          {teamNode.children.map((child, index) => (
            <TeamNode key={`${child.codePrefix}-${index}`} teamNode={child} currentTeam={currentTeam} />
          ))}

          <li className="teamPage-teamHierarchy-addButton">
            <IconButton
              type={IconButtonType.TONAL}
              size={IconButtonSize.X_SMALL}
              variant={IconButtonVariant.EMPHASIZED}
              onClick={() =>
                navigate('/team/add', {
                  state: { parentTeamCodePrefix: teamNode.codePrefix, teamType: TeamType.Division },
                })
              }
              title={formatMessage(Messages.teamHierarchy_createNewTeam)}>
              <Ui16Plus />
            </IconButton>
          </li>
        </ul>
      )}
    </li>
  );
};

export default TeamNode;
